define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "एक और उपयोगकर्ता रजिस्टर करें",

    'incrowd_stats.num_responders': "{{num}} विशेषज्ञ स्वास्थ्य सेवा प्रदाता",
    'incrowd_stats.num_answers': "{{num}} सवालों के जवाब दिए",
    'incrowd_stats.time_to_complete': "औसत दरजे के सर्वेक्षण को पूरा करने के लिए {{num}} मिनट",

    // INCROWD
    'incrowd.about': "के बारे में",
    'incrowd.contact': "संपर्क",
    'incrowd.press': "प्रेस",
    'incrowd.careers': "करियर",
    'incrowd.terms': "शर्तें",
    'incrowd.t_and_c': "नियम और शर्तें",
    'incrowd.faq': "अक्सर पूछे जाने वाले प्रश्न",
    'incrowd.privacy': "गोपनीयता",
    'incrowd.copyright': "{{year}} InCrowd Inc, सभी अधिकार सुरक्षित",
    'incrowd.blog': "ब्लॉग",
    'incrowd.support': "सहयोग",
    'incrowd.info.ios': "क्या आपको मालूम है कि InCrowd नेटवर्क में चिकित्सक अब सीधे अपने सहयोगियों को सवाल भेज सकते हैं? <InCrowd आईओएस ऐप> का उपयोग करके अभी इसे आजमाएं!",
    'incrowd.refer': "हमारे सर्वेक्षण में भाग लेना चाहेंगे? हमारे क्राउड में शामिल होने के लिए आज ही <एक दोस्त को रेफर करें> और आप दोनों 10 अमेरिकी डॉलर (या इसके समतुल्य) कमा सकते हैं। जब आपका सहयोगी किसी सर्वेक्षण का जवाब देगा, उसे भी एक बोनस प्राप्त होगा!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "माइक्रोसर्वेक्षण,",
    'getstarted.encourage.title.two': "भारी प्रभाव",
    'getstarted.encourage.subtitle': "सरल माइक्रोसर्वेक्षणों के माध्यम से नए उत्पादों और उपचारों के विकास पर प्रभाव डालने वाले हजारों योग्यताप्राप्त चिकित्सा पेशेवरों में शामिल हों, और हम आपको इसके लिए मेहनताना भी देगें!",
    'getstarted.encourage.redirect_to_solutions': "स्वास्थ्य-देखभाल पेशेवर नहीं हैं लेकिन InCrowd के बारे में अधिक जानना चाहते हैं?",
    'getstarted.actions.title': "क्या आप योग्यताप्राप्त चिकित्सा पेशेवर हैं?",
    'getstarted.actions.subtitle': "आज ही साइन अप करें और स्वास्थ्य सेवा पर केंद्रित माइक्रोसर्वेक्षणों का जवाब देकर पैसे कमाना शुरू करें",
    'getstarted.button.continue': "शुरू करें",
    'getstarted.referral': "सर्वेक्षणों से धन और %{{referrerName}} से अपने रेफरल बोनस अर्जित करने के लिए साइन अप करें",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "आपका खाता शुरू करने के लिए हमें आपसे कुछ जानकारी की आवश्यकता हैं।",
    'details.profile_details': "प्रोफ़ाइल विवरण",
    'details.address_information': "पते की जानकारी",
    'details.professional_info': "व्यावसायिक जानकारी",
    'details.heading.finally': "...और अंत में",
    'details.how_receive_surveys': "आप सर्वेक्षण किस प्रकार प्राप्त करना चाहते हैं?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "मूल बातें",
    'professionchoice.encourage.subtitle': "आपका पेशा नज़र नहीं आ रहा है? यह सुनिश्चित करने के लिए हमें <यहाँ> बताएं कि जब हम आपका पेशा जोड़ें तब आपको अधिसूचित किया जाए।",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "आप कौन हैं?",
    'authentication.encourage.subtitle': "InCrowd  को आपकी पहचान का सत्यापन करना होगा, लेकिन हम आपकी व्यक्तिगत जानकारी को कभी भी तृतीय पक्षों के नहीं बताएंगे या वितरित करेंगे।",
    'authentication.actions.select_notifications': "चयन करें कि आप हमसे सर्वेक्षण किस तरह से प्राप्त करना चाहेंगे",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "कृपया हमारे द्वारा आपकी जानकारी को मान्य करने तक प्रतीक्षा करें",
    'validation.please_answer': "आपकी व्यक्तिगत जानकारी को मान्य करने में हमारी मदद करने के लिए कृपया निम्नलिखित प्रश्नों का उत्तर दें",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "पुष्टिकरण",
    'confirmation.validation_success.subtitle': "आपका पंजीकरण पूरा हो गया है, InCrowd में आपका स्वागत है! आपको शीघ्र ही ईमेल और/या टेक्स्ट संदेश के द्वारा पुष्टि प्राप्त होगी। शामिल होने के लिए धन्यवाद!",
    'confirmation.validation_error.title': "अतिरिक्त जानकारी की जरूरत है",
    'confirmation.validation_error.subtitle': "%{userFirstName}, क्षमा करें, आपकी व्यक्तिगत जानकारी को मान्य करने में एक समस्या हुई।",
    'confirmation.actions_title': "अब आगे क्या है?",
    'confirmation.go_to_your_profile': "अपने प्रोफ़ाइल पर जाएं",
    'confirmation.validation_success.actions_subtitle': "कुछ ही दिनों में आपको ईमेल या टेक्स्ट संदेश के माध्यम से हमारे 5-10 मिनट के माइक्रो सर्वेक्षण प्राप्त होंगे। क्या अभी तक टेक्स्ट संदेश के माध्यम से सर्वेक्षण प्राप्त करने का चयन नहीं किया है? आप अपने InCrowd प्रोफाइल से किसी भी समय अपनी कम्युनिकेशन सेटिंग्स बदल सकते हैं।",
    'confirmation.validation_error.actions_subtitle': "कृपया स्क्रीन के नीचे दाय़ीं ओर स्थित पॉपअप चैट का उपयोग करके InCrowd टीम के सदस्य से बात करें और किसी भी उल्लेखनीय समस्या को संबोधित करें।",
    'confirmation.referral.info.1': "आप द्वारा %{payoutBusinessDays} बिज़नस दिनों के भीतर सर्वेक्षण पूरा करने पर, आप, और वह व्यक्ति जिसे अपने रेफर किया था,  <will each receive %{currency}%{referralBonusAmount}>। %{currency}%{referralBonusAmount} आपके रिवॉर्ड खाते में जोड़ दिए जाएंगे। आप वरीयताएं अपडेट करने के लिए किसी भी समय अपने <profile> में साइन इन कर सकते हैं, या उन सर्वेक्षणों को एक्सेस कर सकते हैं जिनके लिए आपको आमंत्रित किया गया है।",
    'confirmation.referral.info.2': "क्या कोई सवाल पूछना चाहते हैं? <Chat with us>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "क्या आप योग्य हैं?",
    'regftr.markets.accepting': "InCrowd Answers फिलहाल स्वीकार कर रहा है:",
    'regftr.peers.title': "समकक्ष",
    'regftr.peers.subtitle': "अपनी अनुक्रियाओं की चुलना आपके समकक्षों के उत्तरों से करें और उनके जवाबों से सीखें।",
    'regftr.invites.title': "निमंत्रण",
    'regftr.invites.subtitle': "अपनी आय को अधिक से अधिक करने के लिए ईमेल के माध्यम से या अपने फोन पर नए सर्वेक्षणों की अधिसूचनाएं प्राप्त करें।",
    'regftr.earnings.title': "आय",
    'regftr.earnings.subtitle': "अपनी आय और भुगतान की जानकारी का प्रबंधन और निगरानी करें।",
    'regftr.stats.title': "सांख्यिकी",
    'regftr.stats.subtitle': "आपकी सर्वेक्षण संबंधी सारी जानकारी और उपयोगकर्ता विवरण वाले डैशबोर्ड को एक्सेस करें।",

    'contextual_help.sms': "आपको जारी माइक्रोसर्वेक्षणों की एसएमएस अधिसूचनाएं प्राप्त होंगी। एसएमएस के जरिए आप सर्वेक्षणों में तेजी से प्रवेश करेंगे और अधिक इनाम जीतेंगे। आपकी जानकारी को गोपनीय रखा जाता है और केवल सर्वेक्षण निमंत्रणों के लिए उपयोग किया जाता है।",
    'contextual_help.specialty': "कृपया केवल उन विशेषज्ञताओं को शामिल करें जो, आपकी जिस एनपीआई में आपने विश्वविद्यालयों आदि की अधिसदस्यताएं प्राप्त की हैं उससे या आपकी मुख्य विशेषज्ञताओं के अंतर्गत आने वाले चिकित्सा-क्षेत्रों से संबंधित हैं। यदि भविष्य में आपको अपनी विशेषज्ञताओं में बदलाव करने की आवश्यकता पड़े, तो support@incrowdnow.com पर संपर्क करें।",
    // USER
    'user(s)': "उपयोगकर्ता |||| उपयोगकर्ता",
    'user.login': "लॉगिन करें",
    'user.logout': "लॉग आउट करें",
    'user.register': "पंजीकृत करें",
    'user.invitations': "आमंत्रण",
    'user.email': "ईमेल",
    'user.pass_word': "पासवर्ड",
    'user.mobile': "मोबाइल",
    'user.mobile.hint': "कृपया %{countryName}) के लिए देश कोड (+%{phoneCode} शामिल करें",
    'user.title': "टाइटल",
    'user.title_with_example': "टाइटल (जैसे डॉ., सुश्री, श्री)",
    'user.first_name': "प्रथम नाम",
    'user.last_name': "अंतिम नाम",
    'user.middle_name': "मध्य नाम",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}।",
    'user.anonymous': "एक उपयोगकर्ता",
    'user.anonymous_admin': "एडमिन उपयोगकर्ता",
    'user.dashboard': "डैशबोर्ड",
    'user.profile': "प्रोफ़ाइल",
    'user.profile.picture.upload': "प्रोफ़ाइल तस्वीर अपलोड करें",
    'user.profile.picture.change': "बदलें",
    'user.primary_lang': "प्राथमिक भाषा",
    'user.primary_lang?': "आपकी प्राथमिक भाषा क्या है?",
    'user.survey_langs?': "आप कौन सी भाषाएं धाराप्रवाह बोल सकते हैं?",
    'user.notify_email': "ईमेल द्वारा सूचित करें",
    'user.notify_mobile': "मोबाइल से सूचित करें",
    'user.contact_support': "सहायता से संपर्क करें",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "कृपया <हमसे संपर्क करें>",
    'user.profession': "पेशा",
    'user.profession?': "आपका पेशा क्या है?",
    'user.join_now': "अभी जुड़ें",
    'user.welcome_back': "आपका फिर से स्वागत है!",
    'user.not_a_member?': "अभी तक सदस्य नहीं हैं?",
    'user.accept_terms': "शर्तों को स्वीकार करें",
    'user.accept_terms.yes': "मैं <नियमों और शर्तों> को स्वीकार करता हूं",
    'user.remember_me': "इस डिवाइस पर मुझे याद रखें",
    'user.time_zone': "समय क्षेत्र",
    'user.payment.policy': "हर बार जब भी आपके %{currency}25 रिवॉर्ड एकत्र हो जाएंगे आपको सूचित कर दिया जाएगा और आप अपने InCrowd प्रोफाइल के माध्यम से हमारे भुगतान विकल्पों का चयन कर सकेंगे। क्या कोई सवाल पूछना चाहते हैं? नीचे दी गई चैट विंडो के माध्यम से हमें संपर्क करें।",
    'user.country.live_work?': "आप किस देश में रहते और काम करते हैं?",
    // FORMS
    'form.button.back': "पीछे जाएं",
    'form.button.next': "अगला",
    'form.button.cancel': "रद्द करें",
    'form.button.submit': "सबमिट करें",
    'form.button.continue': "जारी रखें",
    'form.button.close': "बंद करें",
    'form.button.go!': "आगे बढ़ें!",
    'form.button.complete!': "अभी पूरा करें!",
    'form.button.update': "अपडेट करें",
    'form.button.finish': "पूरा करें",
    'form.button.search': "खोजें",
    'form.button.end': "अंत",
    'form.search.no_matches': "कोई मेल नहीं मिला",
    'form.confirm_email': "ईमेल की पुष्टि करें",
    'form.confirm_pass_word': "पासवर्ड की पुष्टि करें",
    'form.required_fields': "आवश्यक फील्ड",
    'form.nothing_selected': "कुछ भी चयनित नहीं",
    'form.confirm_field': "%{formFieldLabel} की पुष्टि करें",
    'form.choice.n/a': "लागू नहीं",
    'form.choice.yes': "हां",
    'form.choice.no': "नहीं",
    'form.choice.blank_for_all': "सभी का चयन करने के लिए खाली छोड़ें",
    'form.choices.select_all': "सभी का चयन करें",
    'form.choices.deselect_all': "सभी को अचयनित करें",
    'form.field.private': "निजी फील्ड",

    // USER ERRORS
    'user.error.dup_email': "दिए गए ईमेल पते के साथ एक अन्य प्रयोक्ता पहले से रजिस्टर कर चुका है। <उसके स्थान पर लॉग इन करें?>",
    'user.error.dup_sms': "एक अन्य उपयोगकर्ता दिए गए मोबाइल नंबर के साथ पहले से पंजीकृत है",
  }
})
